import { forwardRef, type SVGProps } from "react";

export const AllEpisodesIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>All episodes</title>
      <path
        d="M1.6001 3.2002H14.4001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.6001 7.82227H14.4001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.6001 12.4443H8.3501"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.8193 12.5L11.625 13.8721V11.127L13.8193 12.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  );
});
AllEpisodesIcon.displayName = "AllEpisodesIcon";
